const KO = 'ko';
const EN = 'en';
const CH = 'ch';

export { CH, EN, KO };
